import { render } from "./HelpMobile.vue?vue&type=template&id=8309b66a"
import script from "./HelpMobile.vue?vue&type=script&lang=js"
export * from "./HelpMobile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/trifjolngjela/Projects/home-budget/home-budget-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__